var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.6665 10.6667V11.3334C2.6665 11.8638 2.87722 12.3726 3.25229 12.7476C3.62736 13.1227 4.13607 13.3334 4.6665 13.3334H11.3332C11.8636 13.3334 12.3723 13.1227 12.7474 12.7476C13.1225 12.3726 13.3332 11.8638 13.3332 11.3334V10.6667M10.6665 8.00008L7.99984 10.6667M7.99984 10.6667L5.33317 8.00008M7.99984 10.6667V2.66675",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.6cfed93b89ac4e1760fa9eed9a388d9b.svg";
export { ForwardRef as ReactComponent };